import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { Button, SortIcon } from "../../../atoms";

import "./sort.m.css";

const overAllSort = {
  name: "OVERALL",
  value: "current-rank",
  sortable: true,
};

export const SortDropdown = ({ isDesktop, handleSort, columns }) => {
  const [selectedSortColumn, setSelectedSortColumn] = useState("OVERALL");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const sortableColumns = [overAllSort, ...columns.filter((i) => i.sortable)];

  const handleSortColumns = (c) => () => {
    handleSort(c);
    setSelectedSortColumn(c.name);
    setShowDropdown(false);
  };

  const handleDropDown = () => setShowDropdown(!showDropdown);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    if (!isDesktop) {
      if (showDropdown) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    }
  }, [showDropdown]);

  const capitalizeWords = (text) => {
    if (text.includes("EBITDA")) {
      return text;
    }

    return text
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/\bInr\b/g, "INR");
  };

  return (
    <div styleName="wrapper">
      {!isDesktop && (
        <div
          styleName={`overlay ${showDropdown ? "overlay-active" : "overlay-inactive"}`}
          onClick={() => setShowDropdown(false)}
        ></div>
      )}
      <div ref={dropdownRef} styleName={`dropdown ${showDropdown ? "dropdown-active" : "dropdown-inactive"}`}>
        <div styleName="dropdown-heading">Sort By</div>
        <div styleName="dropdown-close" onClick={() => setShowDropdown(false)}>
          {/* <SvgIconHandler type="close" height="12" width="12" viewBox="0 0 12 12" /> */}
        </div>
        <div>
          {sortableColumns.map((c, i) => {
            return (
              <div
                key={i}
                onClick={handleSortColumns(c)}
                styleName={`dropdown-items ${c.name === selectedSortColumn ? "dropdown-items-active" : ""}`}
              >
                {capitalizeWords(c.name)}
              </div>
            );
          })}
        </div>
      </div>
      <Button onClickFunction={handleDropDown}>
        {isDesktop ? (
          <>
            {"Sort by: "} <span styleName="active-item"> {capitalizeWords(selectedSortColumn)}</span>
            {/* <SvgIconHandler type={"arrow"} width={24} height={24} viewBox="0 0 24 24" /> */}
          </>
        ) : (
          // <SortIcon />
          ''
        )}
      </Button>
    </div>
  );
};

SortDropdown.propTypes = {
  handleSort: PropTypes.func,
  isDesktop: PropTypes.string,
  columns: PropTypes.array,
};
